import script from "./BonusDescriptionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BonusDescriptionModal.vue?vue&type=script&setup=true&lang=ts"

import "./BonusDescriptionModal.vue?vue&type=style&index=0&id=1f2e705c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2e705c"]])

export default __exports__